document.addEventListener('DOMContentLoaded', function () {
  var modalEl = document.getElementById('quizModal');
  if (!modalEl) return;

  var Modal = window.bootstrap && window.bootstrap.Modal;
  var modalInstance = Modal ? new Modal(modalEl) : null;

  var steps = Array.prototype.slice.call(modalEl.querySelectorAll('.quiz-step'));
  var totalSteps = steps.length;
  var currentStep = 0;

  var nextBtn = document.getElementById('quizNextBtn');
  var backBtn = document.getElementById('quizBackBtn');
  var pickedCountEl = document.getElementById('quizPickedCount');
  var problemGrid = document.getElementById('quizProblemGrid');
  var conditionGrid = document.getElementById('quizConditionGrid');
  var conditionTitle = document.getElementById('quizConditionTitle');

  var answers = { category: null, problems: [], condition: null, budget: null };
  var lastOpener = null;

  var PROBLEM_SETS = {
    'Hair & Scalp': ['Hairfall', 'Dandruff', 'Slow hair growth', 'Split ends', 'Itchy scalp', 'Sleep'],
    'Skin': ['Acne', 'Dark spots', 'Dryness', 'Oiliness', 'Sunburn', 'Fine lines'],
    'Health & Energy': ['Low energy', 'Poor sleep', 'Stress', 'Weight goals', 'Immunity', 'Digestion'],
    'Fashion & Styling': ['Fit issues', 'What to pair', 'Building a wardrobe'],
    'Technology': ['Battery life', 'Screen protection']
  };
  var CONDITION_SETS = {
    'Hair & Scalp': { title: "How's your scalp right now", options: ['Oily', 'Dry', 'Flaky', 'Sensitive', 'Normal'] },
    'Skin': { title: "How's your skin right now", options: ['Oily', 'Dry', 'Combination', 'Sensitive', 'Normal'] },
    'default': { title: 'How would you describe this', options: ['Mild', 'Moderate', 'Frequent', 'Not sure'] }
  };
  /* One vocabulary for the whole shop. assets/vro-personalization.js owns
     it, beside the CATEGORIES that have to agree with it; the lists above
     are only what this modal falls back to if that script did not load.
     Read through here rather than indexed directly, so a category the
     merchant renamed still finds its questions and its products. */
  function problemsFor(name) {
    var q = window.VroPersonalization && window.VroPersonalization.quiz;
    if (q && q.problemsFor) {
      var list = q.problemsFor(name);
      if (list.length) return list;
    }
    return PROBLEM_SETS[name] || PROBLEM_SETS['Skin'];
  }
  function conditionsFor(name) {
    var q = window.VroPersonalization && window.VroPersonalization.quiz;
    if (q && q.conditionsFor) return q.conditionsFor(name);
    return CONDITION_SETS[name] || CONDITION_SETS['default'];
  }


  /* The departments this opening of the quiz is about.

     A quiz opened from a category — the chip on a Face Care listing, the
     Retake on a perfume — is about that category, and offering Hair or
     Technology beside it is how a skin question ended in a hair mask. The
     opener can say so itself (data-quiz-category, or a category chip's own
     data-quiz-value); otherwise the page does, from the collection or the
     product the modal was rendered on (snippets/quiz-modal.liquid). The
     engine decides what those mean (VroPersonalization.quiz.departmentsFor),
     so the words here and in the results are one list. Empty = unscoped:
     every department, exactly as before. */
  function quizApi() {
    return (window.VroPersonalization && window.VroPersonalization.quiz) || null;
  }

  function scopeFor(opener) {
    var q = quizApi();
    if (!q || !q.keyFor || !q.departmentsFor) return [];

    var own = opener && opener.closest('[data-quiz-category]');
    var named = own ? own.getAttribute('data-quiz-category') : '';
    if (!named && opener && opener.getAttribute('data-quiz-select') === 'category') {
      named = opener.getAttribute('data-quiz-value') || '';
    }
    var key = named ? q.keyFor(named) : null;
    if (key) return [key];

    return q.departmentsFor({
      handle: modalEl.getAttribute('data-quiz-context-handle') || '',
      title: modalEl.getAttribute('data-quiz-context-title') || '',
      tags: modalEl.getAttribute('data-quiz-context-tags') || ''
    });
  }

  /* Shows only the scoped departments' chips on the first step, adding one
     for a department this modal has no chip for (Fragrance, Lifestyle), and
     puts every chip back when the quiz is unscoped. */
  var categoryGrid = modalEl.querySelector('.quiz-category-grid');
  function applyScope(scope) {
    if (!categoryGrid) return;
    var q = quizApi();
    Array.prototype.slice.call(categoryGrid.querySelectorAll('[data-quiz-scope-added]')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    var shown = {};
    categoryGrid.querySelectorAll('.quiz-category-btn').forEach(function (btn) {
      var key = q && q.keyFor ? q.keyFor(btn.getAttribute('data-quiz-value')) : null;
      var keep = !scope.length || (key && scope.indexOf(key) > -1);
      var cell = btn.parentNode === categoryGrid ? btn : btn.parentNode;
      cell.classList.toggle('d-none', !keep);
      if (keep && key) shown[key] = true;
    });
    scope.forEach(function (key) {
      if (shown[key]) return;
      var cell = document.createElement('div');
      cell.className = 'col-4';
      cell.setAttribute('data-quiz-scope-added', '');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quiz-category-btn';
      btn.setAttribute('data-quiz-select', 'category');
      btn.setAttribute('data-quiz-value', key);
      btn.textContent = key;
      cell.appendChild(btn);
      categoryGrid.appendChild(cell);
    });
  }

  function buildPillGrid(container, options, selectKey, multi) {
    container.innerHTML = '';
    options.forEach(function (label) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quiz-pill-select';
      btn.textContent = label;
      btn.setAttribute('data-quiz-select', selectKey);
      btn.setAttribute('data-quiz-value', label);
      btn.setAttribute('data-quiz-multi', multi ? 'true' : 'false');
      container.appendChild(btn);
    });
  }

  function refreshNextState() {
    var step = steps[currentStep];
    var key = step.getAttribute('data-quiz-step');
    var valid = false;
    if (key === '0') valid = !!answers.category;
    if (key === '1') valid = answers.problems.length > 0;
    if (key === '2') valid = !!answers.condition;
    if (key === '3') valid = !!answers.budget;
    if (key === '4') valid = true;
    nextBtn.disabled = !valid;
    nextBtn.textContent = key === '3' ? 'Show me my results' : (key === '4' ? 'Done' : 'Next');
  }

  /* 1 when the quiz is scoped to a single department: that answer is
     already given, so the quiz opens on its questions and Back stops there. */
  var firstStep = 0;

  function showStep(index) {
    steps.forEach(function (s, i) { s.classList.toggle('d-none', i !== index); });
    backBtn.style.visibility = index <= firstStep ? 'hidden' : 'visible';
    currentStep = index;
    refreshNextState();
  }

  function goToStep2Setup() {
    var set = problemsFor(answers.category);
    buildPillGrid(problemGrid, set, 'problem', true);
  }

  function goToStep3Setup() {
    var cond = conditionsFor(answers.category);
    conditionTitle.textContent = cond.title;
    buildPillGrid(conditionGrid, cond.options, 'condition', false);
  }

  modalEl.addEventListener('click', function (e) {
    var target = e.target.closest('[data-quiz-select]');
    if (!target) return;

    var key = target.getAttribute('data-quiz-select');
    var value = target.getAttribute('data-quiz-value');
    var multi = target.getAttribute('data-quiz-multi') === 'true';

    if (key === 'category') {
      answers.category = value;
      modalEl.querySelectorAll('.quiz-category-btn').forEach(function (b) { b.classList.toggle('selected', b === target); });
    } else if (key === 'problem') {
      if (multi) {
        var idx = answers.problems.indexOf(value);
        if (idx > -1) {
          answers.problems.splice(idx, 1);
          target.classList.remove('selected');
        } else if (answers.problems.length < 3) {
          answers.problems.push(value);
          target.classList.add('selected');
        }
        if (pickedCountEl) pickedCountEl.textContent = answers.problems.length;
      }
    } else if (key === 'condition') {
      answers.condition = value;
      conditionGrid.querySelectorAll('.quiz-pill-select').forEach(function (b) { b.classList.toggle('selected', b === target); });
    } else if (key === 'budget') {
      answers.budget = value;
      target.closest('.quiz-pill-grid').querySelectorAll('.quiz-pill-select').forEach(function (b) { b.classList.toggle('selected', b === target); });
    }

    refreshNextState();
  });

  /* Where the four answers end up.

     On a page that has the "Picked for you" section (the home page), the
     modal hands the answers over and gets out of the way: the section has
     room for a real rail and matches strictly against the store's own
     concern and benefit data, which a modal half this size cannot show and
     a keyword search cannot promise. Everywhere else the modal renders the
     picks itself via assets/quiz-results.js, exactly as before, and without
     that script the old redirect still stands in — the last step is never a
     dead end on any page. */
  function saveAnswers() {
    try {
      var p = window.VroPersonalization && window.VroPersonalization.profile;
      if (p && p.setQuiz && answers && answers.category) p.setQuiz(answers);
    } catch (e) { /* storage unavailable */ }
  }

  function showResults() {
    var slot = modalEl.querySelector('[data-quiz-results]');
    if (!slot) return;

    var origin = lastOpener ? lastOpener.closest('.shopify-section') : null;
    if (window.VroPersonalization &&
        window.VroPersonalization.deliver(answers, 'quiz-modal', { origin: origin })) {
      slot.innerHTML = '';
      var note = document.createElement('p');
      note.className = 'quiz-step-subtitle';
      note.textContent = 'Your picks are ready on the page behind this.';
      slot.appendChild(note);
      if (modalInstance) modalInstance.hide();
      return;
    }

    /* The modal stays open and answers itself, by the same engine the
       picks section uses — the department gate, the budget and the
       ranking. Never the keyword-and-price search below, which is what
       once answered a screen-protection question with two shirts and a
       peeling gel. */
    if (window.VroPersonalization && window.VroPersonalization.renderInto) {
      /* Kept on the profile here too, so a product page (where there is no
         picks section to save it) still remembers what was answered and
         can say so — assets/vro-pdp-memory.js, assets/vro-pdp-match.js. */
      saveAnswers();
      window.VroPersonalization.renderInto(slot, answers);
      return;
    }

    /* Only if the engine is missing entirely. */
    if (!window.VroQuizResults) {
      slot.innerHTML = '';
      var link = document.createElement('a');
      link.className = 'quiz-results-all';
      link.textContent = 'See my results';
      link.href = '/search?q=' + encodeURIComponent(
        [answers.category ? answers.category.split(' & ')[0] : '']
          .concat(answers.problems, answers.condition || '')
          .filter(Boolean).join(' ')
      );
      slot.appendChild(link);
      return;
    }
    window.VroQuizResults.render(slot, answers);
  }

  nextBtn.addEventListener('click', function () {
    if (currentStep === 0) goToStep2Setup();
    if (currentStep === 1) goToStep3Setup();
    if (currentStep < totalSteps - 1) {
      showStep(currentStep + 1);
      if (currentStep === totalSteps - 1) showResults();
    } else if (modalInstance) {
      modalInstance.hide();
    }
  });

  backBtn.addEventListener('click', function () {
    if (currentStep > firstStep) showStep(currentStep - 1);
  });

  modalEl.addEventListener('show.bs.modal', function () {
    answers = { category: null, problems: [], condition: null, budget: null };
    if (pickedCountEl) pickedCountEl.textContent = '0';
    modalEl.querySelectorAll('.quiz-category-btn').forEach(function (b) { b.classList.remove('selected'); });

    var scope = scopeFor(lastOpener);
    applyScope(scope);
    firstStep = 0;
    if (scope.length === 1) {
      answers.category = scope[0];
      var q = quizApi();
      modalEl.querySelectorAll('.quiz-category-btn').forEach(function (b) {
        b.classList.toggle('selected', q.keyFor(b.getAttribute('data-quiz-value')) === scope[0]);
      });
      goToStep2Setup();
      firstStep = 1;
    }
    showStep(firstStep);
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-quiz-open]');
    if (opener && modalInstance) {
      /* Remembered so the picks can land beside whatever asked — the chip
         on a collection page, the banner on the home page — rather than
         wherever the picks section sits in that template. */
      lastOpener = opener;
      modalInstance.show();
    }
  });
});
